import React, { useContext, useEffect, useState } from "react";
import MDModal from "components/MDModal";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import PropTypes from "prop-types";
import MDBox from "components/MDBox";
import { LoginFormContext } from "context/LoginFormContext";
import { ModalContext } from "context/ModalContext";
import { MODULES } from "helpers/constant";
import UpdateStatus from "components/MDUpdateStatus";
import { committeeList } from "Apis/committees";
import DefaultCell from "examples/Tables/DataTable/components/DefaultCell";
import { getCommitteeById } from "Apis/committees";
import { deleteCommitteeById } from "Apis/committees";
import CommitteeForm from "./Form";
import { CommitteeContext } from "context/CommitteeContext";
import { Avatar } from "@mui/material";
import MDActionButton from "components/MDActionButton";
import colors from "assets/theme/base/colors";
import Imagepreview from "components/MDImagePreview";
import { SEARCH_INPUT_TYPES } from "helpers/constant";
import moment from "moment";

const Committees = () => {
  const { showMessageNotification, setOpen, formIsEdit, setFormIsEdit } = useContext(ModalContext);
  const {
    setNotification,
    modules,
    getModuleAccess,
    isLoading,
    setIsLoading,
    filterLoader,
    setFilterLoader,
    access,
  } = useContext(LoginFormContext);
  const { setEditData } = useContext(CommitteeContext);
  //handleMemberList, memberData
  const [committee, setCommittee] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [defaultFilter, setDefaultFilter] = useState({
    currentPage: 1,
    itemsPerPage: 10,
    sortBy: [{ id: "id", value: "desc" }],
  });

  const [filterVal, setFilterVal] = useState({
    name: "",
    address: "",
    contact_details: "",
    extra_information: "",
  });

  const handleFilter = (accessor, value) => {
    setFilterLoader(true);
    setFilterVal({ ...filterVal, [accessor]: value });
    setDefaultFilter((prev) => ({ ...prev, currentPage: 1 }));
  };

  let Obj = {
    ...defaultFilter,
    filters: {
      name: filterVal?.name,
      address: filterVal?.address,
      contact_details: filterVal?.contact_details,
      extra_information: filterVal?.extra_information,
      is_active: filterVal?.is_active?.value,
    },
  };

  const committeeData = async (data) => {
    let response = await committeeList(Obj);
    filterLoader ? setIsLoading(false) : setIsLoading(true);
    if (response?.status === 200) {
      setCommittee(response?.data?.data?.rows);
      setRowCount(response?.data?.data?.count);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getModuleAccess(MODULES.COMMITTEE);
  }, [modules]);

  useEffect(() => {
    committeeData();
  }, [filterVal, defaultFilter]);

  // useEffect(() => {
  //   handleMemberList();
  // }, []);

  const handleEditDelete = async (row, type) => {
    if (type === "Edit") {
      let response = await getCommitteeById(row.id);
      if (response?.status === 200) {
        setFilterLoader(false);
        setEditData(response?.data?.data);
        setOpen(true);
        setFormIsEdit(true);
      }
    }
    if (type === "Delete") {
      showMessageNotification({
        title: "Are you sure?",
        text: "You want to delete this member!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          let deleteResponse = await deleteCommitteeById(row.id);
          if (deleteResponse?.status === 200) {
            setFilterLoader(false);
            setOpen(false);
            committee?.length === 1 && setDefaultFilter({ ...defaultFilter, currentPage: 1 });
            committeeData();
            setNotification({
              color: "success",
              icon: "check",
              title: "Success",
              content: deleteResponse.data.message,
              open: true,
            });
          } else {
            setNotification({
              color: "error",
              icon: "check",
              title: "error",
              content: deleteResponse.data.message,
              open: true,
            });
          }
        }
      });
    }
  };

  // const [selectedImage, setSelectedImage] = useState(null);
  // const [isImageModalOpen, setIsImageModalOpen] = useState(false);

  // const handleImageClick = (imageUrl) => {
  //   setSelectedImage(imageUrl);
  //   setIsImageModalOpen(true);
  // };

  let data = {
    isFilter: true,
    columns: [
      // {
      //   Header: "Member",
      //   accessor: "member_id",
      //   minWidth: "85px",
      //   sort: false,
      //   filterLabel: "Member",
      //   filterAccessor: "name",
      //   filterInputType: SEARCH_INPUT_TYPES.TEXT,
      //   filterHandleChange: handleFilter,
      //   Cell: ({ value, row }) => {
      //     const member = memberData.find((item) => item?.value === value);
      //     const imageUrl = member?.imageUrl;

      //     const [imgError, setImgError] = React.useState(false);

      //     return (
      //       <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
      //         {imageUrl && !imgError ? (
      //           <img
      //             src={imageUrl}
      //             alt="image"
      //             onError={() => setImgError(true)}
      //             onClick={() => handleImageClick(imageUrl)}
      //             style={{
      //               height: "50px",
      //               width: "50px",
      //               borderRadius: "100%",
      //               objectFit: "cover",
      //               border: `1px solid ${imageBorder.borderColor}`,
      //               cursor: "pointer",
      //             }}
      //           />
      //         ) : (
      //           <Avatar
      //             sx={{
      //               height: "50px",
      //               width: "50px",
      //               "&:hover": {
      //                 background: `1px solid ${imageBorder.borderColor}`,
      //               },
      //             }}
      //           />
      //         )}
      //         <DefaultCell value={member ? member.label : "-"} />
      //       </div>
      //     );
      //   },
      // },
      {
        Header: "Full Name",
        accessor: "name",
        minWidth: "85px",
        sort: true,
        filterLabel: "Full Name",
        filterAccessor: "name",
        filterInputType: SEARCH_INPUT_TYPES.TEXT,
        filterHandleChange: handleFilter,
        Cell: ({ value }) => <DefaultCell value={value ? value : "-"} />,
      },
      {
        Header: "Address",
        accessor: "address",
        minWidth: "85px",
        sort: true,
        filterLabel: "Address",
        filterAccessor: "address",
        filterInputType: SEARCH_INPUT_TYPES.TEXT,
        filterHandleChange: handleFilter,
        Cell: ({ value }) => <DefaultCell value={value || "-"} />,
      },
      {
        Header: "Contact Details",
        accessor: "contact_details",
        minWidth: "85px",
        sort: true,
        filterLabel: "Contact Details",
        filterAccessor: "contact_details",
        filterInputType: SEARCH_INPUT_TYPES.TEXT,
        filterHandleChange: handleFilter,
        Cell: ({ value }) => <DefaultCell value={value ? value : "-"} />,
      },
      {
        Header: "Extra Details",
        accessor: "extra_information",
        minWidth: "85px",
        sort: true,
        filterLabel: "Extra Details",
        filterAccessor: "extra_information",
        filterInputType: SEARCH_INPUT_TYPES.TEXT,
        filterHandleChange: handleFilter,
        Cell: ({ value }) => <DefaultCell value={value ? value : "-"} />,
      },
      {
        Header: "Created date",
        accessor: "createdAt",
        sort: true,
        Cell: ({ value }) => (
          <DefaultCell value={value ? moment(value).format("DD-MM-YYYY hh:mm A") : "-"} />
        ),
      },
      {
        Header: "Status",
        accessor: "is_active",
        minWidth: "115px",
        filterLabel: "Status",
        filterAccessor: "is_active",
        filterInputType: SEARCH_INPUT_TYPES.AUTO_COMPLETE,
        filterHandleChange: handleFilter,
        filterOption: [
          { label: "Active", value: "1" },
          { label: "Inactive", value: "0" },
        ],
        Cell: ({ row }) => (
          <UpdateStatus
            tableNameProp="committee"
            data={row}
            access={access?.write_access ? true : false}
          />
        ),
      },
      {
        Header: "Action",
        accessor: "action",
        width: "12%",
        Cell: ({ value, row }) => (
          <MDBox sx={{ display: "flex", gap: "10px", alignItems: "center" }}>
            {access?.write_access && (
              <MDActionButton type="edit" onClick={() => handleEditDelete(row.original, "Edit")} />
            )}
            {access?.delete_access && (
              <MDActionButton
                type="delete"
                onClick={() => handleEditDelete(row.original, "Delete")}
              />
            )}
          </MDBox>
        ),
      },
    ],
    rows: committee,
  };

  return (
    !isLoading && (
      <>
        <DashboardLayout>
          <DashboardNavbar />
          <>
            <MDModal
              hasButton={access?.write_access ?? false}
              btnText="add Committee"
              modalHead={`${formIsEdit ? "Edit" : "Add"} Committee`}
            >
              <CommitteeForm committeeData={committeeData} />
            </MDModal>
            <DataTable
              table={data}
              isSorted={false}
              entriesPerPage={true}
              showTotalEntries={true}
              noEndBorder
              canFilter
              getDataList={committeeData}
              rowCount={rowCount}
              //   canSearch={true}
              tableTitle="Committee List"
              defaultFilter={defaultFilter}
              setDefaultFilter={setDefaultFilter}
            />
            {/* {selectedImage && (
              <Imagepreview
                open={isImageModalOpen}
                onClose={() => setIsImageModalOpen(false)}
                imageUrl={selectedImage}
              />
            )} */}
          </>
        </DashboardLayout>
      </>
    )
  );
};
Committees.propTypes = {
  value: PropTypes.string,
  row: PropTypes.string,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  imageUrl: PropTypes.string.isRequired,
};
export default Committees;
